<template>
    <o-form :title="$t('sandoz.contract')"
            :url="'/api/sandoz/contracts/' + $route.params.id + '?include=addresses,lines.contract_address,lines,kam_verification_lines,lines.product,lines.attributes,lines.deliveries,lines.invoices,pdfs,pdfs.user,import_jobs,word_files.user,previous,invoices,access,access.user'"
            class="ortic-form-horizontal" ref="form" @loaded="loaded">
        <template slot-scope="props">
            <div class="btn-toolbar" role="toolbar">
                <div class="btn-group mr-2 mb-4" role="group">
                  <a :href="'/api/sandoz/contracts/' + $route.params.id + '/invoice/1/3'" class="btn btn-secondary" target="_blank">Invoice Q1</a>
                  <a :href="'/api/sandoz/contracts/' + $route.params.id + '/invoice/4/6'" class="btn btn-secondary" target="_blank">Invoice Q2</a>
                  <a :href="'/api/sandoz/contracts/' + $route.params.id + '/invoice/7/9'" class="btn btn-secondary" target="_blank">Invoice Q3</a>
                  <a :href="'/api/sandoz/contracts/' + $route.params.id + '/invoice/10/12'" class="btn btn-secondary" target="_blank">Invoice Q4</a>
                </div>
                <div class="btn-group mr-2 mb-4" role="group" >
                  <a v-if="props.item.payment_schema === 'semester'" :href="'/api/sandoz/contracts/' + $route.params.id + '/invoice/1/6'" class="btn btn-secondary" target="_blank">Invoice S1</a>
                  <a v-if="props.item.payment_schema === 'semester'" :href="'/api/sandoz/contracts/' + $route.params.id + '/invoice/7/12'" class="btn btn-secondary" target="_blank">Invoice S2</a>
                  <a :href="'/api/sandoz/contracts/' + $route.params.id + '/invoice/1/12'" class="btn btn-secondary" target="_blank">Invoice Year</a>
                </div>
                <div class="btn-group mr-2 mb-4" role="group">
                  <o-button native-type="button" @click="vendorForm" class="btn btn-secondary" target="_blank">Vendor Form</o-button>
                </div>
                <div class="btn-group mr-2 mb-4" role="group">
                  <o-button native-type="button" @click="pdfContract" class="btn btn-secondary" target="_blank">PDF Contract</o-button>
                </div>
                <div class="btn-group mr-2 mb-4" role="group">
                  <template-download-button v-if="$route.params.id !== 'new'" :contract-id="$route.params.id"/>
                </div>
            </div>

            <b-row>
                <b-col>
                    <o-input :errorField="'contract_no'" :label="$t('sandoz.contract_no')" v-model="props.item.contract_no"/>
                    <o-input :errorField="'contract_year'" :label="$t('sandoz.contract_year')" v-model="props.item.contract_year" type="number"/>
                    <o-value-select :items="filteredTypes" :label="$t('sandoz.type')" v-model="props.item.type" @input-object="setFieldVisibility(props.item)" :readonly="props.item.type && props.item.type.endsWith('_KUKO')"/>
                    <o-input :errorField="'customer_external_id'" :label="$t('sandoz.customer_external_id')" v-model="props.item.customer_external_id"/>
                    <o-input :errorField="'customer_no_xpris'" :label="$t('sandoz.customer_no_xpris')" v-model="props.item.customer_no_xpris"/>
                    <o-input :errorField="'customer_no_sap'" :label="$t('sandoz.customer_no_sap')" v-model="props.item.customer_no_sap"/>
                    <o-input :errorField="'customer_no_gln'" :label="$t('sandoz.customer_no_gln')" v-model="props.item.customer_no_gln"/>
                    <o-input :errorField="'customer_no_vendor'" :label="$t('sandoz.customer_no_vendor')" v-model="props.item.customer_no_vendor"/>
                    <o-input :errorField="'responsible_sales_person'" :label="$t('sandoz.responsible_sales_person')" v-model="props.item.responsible_sales_person"/>
                    <o-input :errorField="'responsible_sales_person_email'" :label="$t('sandoz.responsible_sales_person_email')" v-model="props.item.responsible_sales_person_email"/>

                    <o-form-group :label="$t('sandoz.status')">
                      <b-input-group>
                        <o-value-select-control v-model="props.item.status" :items="status"></o-value-select-control>
                        <b-input-group-append>
                          <b-button @click="showStatusChanges(props.item)" variant="secondary">
                            <fa icon="info-circle"></fa>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </o-form-group>
                </b-col>
                <b-col>
                    <o-form-group :label="$t('sandoz.previous_contract')" class="mb-2">
                        <b-input-group>
                            <input :value="props.item.previous && props.item.previous.contract_no ? props.item.previous.contract_no : null"
                                   type="text" class="form-control"  disabled>
                            <b-input-group-append>
                                <b-btn variant="primary" @click.prevent="$refs.addPreviousContractModel.show()">
                                  <fa icon="ellipsis-h"/>
                                </b-btn>
                            </b-input-group-append>
                            <input v-model="props.item.previous_contract" type="hidden">
                        </b-input-group>
                    </o-form-group>
                    <o-form-group>
                        <div class="w-100">
                            <b-form-checkbox v-model="props.item.no_previous_contract" :value="true" :unchecked-value="false">
                                {{$t('sandoz.no_previous_contract')}}
                            </b-form-checkbox>
                        </div>
                    </o-form-group>
                    <o-value-select :errorField="'payment_schema'" :items="paymentSchema" :label="$t('sandoz.payment_schema')" v-model="props.item.payment_schema"/>
                    <o-input :errorField="'turnover'" :label="$t('sandoz.turnover')" v-model="props.item.turnover" type="number"/>
                    <o-input :errorField="'turnover_expectation'" :label="$t('sandoz.turnover_expectation')" v-model="props.item.turnover_expectation" type="number"/>
                    <o-input :errorField="'services'" :label="$t('sandoz.services')" v-model="props.item.services" type="number"/>
                    <o-input :errorField="'marketing_activities'" :label="$t('sandoz.marketing_activities')" v-model="props.item.marketing_activities" type="number"/>
                    <o-input :errorField="'marketing_activities_percentage'"
                             :label="$t('sandoz.marketing_activities_percentage')"
                             v-model="props.item.marketing_activities_percentage" type="number" format="percentage"
                             mask="XX.XXXX" append="%"/>
                    <o-input :errorField="'discount'" :label="$t('sandoz.discount')" v-model="props.item.discount" type="number"/>
                    <o-form-group :label="$t('sandoz.kuko_id')">
                        <div class="w-100">
                            <div v-if="(props.item.kukos && props.item.kukos.length > 0) || props.item.kuko_link" class="table-responsive mb-2">
                                <table class="table table-bordered table-sm table-hover mb-0 bg-white">
                                    <thead class="thead-light">
                                        <tr>
                                            <th class="align-middle px-3 py-2 font-weight-bold">{{ $t('sandoz.kuko_id') }}</th>
                                            <th class="align-middle text-right px-3 py-2" style="width: 220px;">{{ $t('core.actions') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="props.item.kukos && props.item.kukos.length > 0">
                                            <tr v-for="kuko in props.item.kukos" :key="kuko.id">
                                                <td class="align-middle px-3 font-weight-bold">{{ kuko.id }}</td>
                                                <td class="align-middle text-right px-3 py-1">
                                                    <button class="btn btn-sm btn-outline-secondary mr-1" type="button" @click="openKuko(kuko.id)">
                                                        <i class="fa fa-external-link-alt mr-1"></i>{{ $t('sandoz.open_kuko') }}
                                                    </button>
                                                    <button v-if="user && user.is_super_user" class="btn btn-sm btn-outline-danger" type="button" @click="unlinkKukoConfirm(kuko.id)">
                                                        <i class="fa fa-unlink mr-1"></i>{{ $t('sandoz.unlink') }}
                                                    </button>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else-if="props.item.kuko_link">
                                            <tr>
                                                <td class="align-middle px-3 font-weight-bold">{{ props.item.kuko_link }}</td>
                                                <td class="align-middle text-right px-3 py-1">
                                                    <button class="btn btn-sm btn-outline-secondary mr-1" type="button" @click="openKuko(props.item.kuko_link)">
                                                        <i class="fa fa-external-link-alt mr-1"></i>{{ $t('sandoz.open_kuko') }}
                                                    </button>
                                                    <button v-if="user && user.is_super_user" class="btn btn-sm btn-outline-danger" type="button" @click="unlinkKukoConfirm(props.item.kuko_link)">
                                                        <i class="fa fa-unlink mr-1"></i>{{ $t('sandoz.unlink') }}
                                                    </button>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="text-muted mb-2 font-italic small">
                                {{ $t('sandoz.no_kuko_linked') || 'No KUKOs linked' }}
                            </div>
                            <div v-if="user && user.is_super_user">
                                <button class="btn btn-outline-primary btn-sm" type="button" @click="fetchKukos(false)">
                                    <i class="fa fa-link mr-1"></i>{{ $t('sandoz.link') }}
                                </button>
                            </div>
                        </div>
                    </o-form-group>
                    <o-input :errorField="'discount_percentage'" :label="$t('sandoz.discount_percentage')"
                             v-model="props.item.discount_percentage" type="number" format="percentage" mask="XX.XXXX"
                             append="%"/>

                    <o-value-select v-model="props.item.created_by_user_id" :label="$t('core.created_by')"
                          text-field="name"
                          url="/api/system/users?filter%5Bactive%5D=1%25&sortBy=name"
                          value-field="id"></o-value-select>
                </b-col>
            </b-row>

            <b-button v-b-toggle.collapse-detail class="m-1" variant="secondary">
              <fa :icon="detailOpen ? 'arrow-down' : 'arrow-right'"/>
              Details
            </b-button>
            <b-collapse id="collapse-detail" v-model="detailOpen">
              <b-row>
                  <b-col>
                      <o-input :errorField="'contract_no_version'" :label="$t('sandoz.contract_no_version')" v-model="props.item.contract_no_version"/>
                      <o-input :errorField="'language'" :label="$t('core.language')" v-model="props.item.language"/>
                      <o-form-group :label="$t('sandoz.region')" v-if="isRegionVisible()">
                        <b-select :options="regions" v-model="props.item.region_id" value-field="id" text-field="region"></b-select>
                      </o-form-group>
                      <o-input :errorField="'invest_turnover_percentage'" :label="$t('sandoz.invest_turnover_percentage')"
                              v-model="props.item.invest_turnover_percentage" type="number"
                              format="percentage"
                              mask="XX.XXXX" append="%"/>
                      <o-input :errorField="'invest_growth'" :label="$t('sandoz.invest_growth')" v-model="props.item.invest_growth" type="number"/>
                      <o-input :errorField="'distributor_2'" :label="$t('sandoz.distributor_2')" v-model="props.item.distributor_2"/>
                      <o-input :errorField="'distributor_3'" :label="$t('sandoz.distributor_3')" v-model="props.item.distributor_3"/>
                      <o-input :errorField="'customer_group'" :label="$t('sandoz.customer_group')" v-model="props.item.customer_group"/>
                      <o-input :errorField="'growth_forecast'" :label="$t('sandoz.growth_forecast')" v-model="props.item.growth_forecast" type="number"/>
                      <o-textarea :errorField="'reason_businesscase'" :label="$t('sandoz.reason_businesscase')" v-model="props.item.reason_businesscase"/>
                      <o-textarea :errorField="'note'" :label="$t('core.note')" v-model="props.item.note"/>

                      <o-form-group>
                          <div class="w-100">
                              <b-form-checkbox v-model="props.item.delivery_required" :value="true" :unchecked-value="false">{{$t('sandoz.delivery_required')}}</b-form-checkbox>
                              <b-form-checkbox v-model="props.item.available_marketing_items" :value="true" :unchecked-value="false">{{$t('sandoz.available_marketing_items')}}</b-form-checkbox>
                              <b-form-checkbox v-model="props.item.disclosure_requirement" :value="true" :unchecked-value="false">{{$t('sandoz.disclosure_requirement')}}</b-form-checkbox>
                          </div>
                      </o-form-group>

                      <o-form-group :label="$t('sandoz.new_customer')" class="new_customer_radio">
                        <b-form-radio v-model="props.item.new_customer" name="new_customer" value="x">{{$t('sandoz.yes')}}</b-form-radio>
                        <b-form-radio v-model="props.item.new_customer" name="new_customer" :value="null">{{$t('sandoz.no')}}</b-form-radio>
                      </o-form-group>

                      <o-input :errorField="'bank_address'" :label="$t('sandoz.bank_address')" v-model="props.item.bank_address"/>
                      <o-input :errorField="'bank_name'" :label="$t('sandoz.bank_name')" v-model="props.item.bank_name"/>
                      <o-input :errorField="'bank_city'" :label="$t('sandoz.bank_city')" v-model="props.item.bank_city"/>
                      <o-input :errorField="'bank_account'" :label="$t('sandoz.bank_account')" v-model="props.item.bank_account"/>
                      <o-input :errorField="'iban_no'" :label="$t('sandoz.iban_no')" v-model="props.item.iban_no"/>
                      <o-input :errorField="'accountholder_name'" :label="$t('sandoz.accountholder_name')" v-model="props.item.accountholder_name"/>
                      <o-input :errorField="'accountholder_address'" :label="$t('sandoz.accountholder_address')" v-model="props.item.accountholder_address"/>
                      <b-form-checkbox v-model="props.item.vat" :value="'x'" :unchecked-value="''">{{$t('sandoz.vat_obligation')}}</b-form-checkbox>
                      <o-input v-if="props.item.vat" :errorField="'vat_number'" :label="$t('sandoz.vat_number')" v-model="props.item.vat_number"/>
                      <o-input errorField="buying_group_code_when_uploaded" :label="$t('sandoz.buying_group_code_when_uploaded')" v-model="props.item.buying_group_code_when_uploaded"/>
                      <o-form-group :label="$t('sandoz.buying_group_code_when_uploaded')">
                        <b-input-group>
                          <b-input v-model="props.item.buying_group_code_when_uploaded"/>
                          <b-input-group-append>
                            <b-button @click="$bvModal.msgBoxOk($i18n.t('sandoz.buying_group_code_when_uploaded_info'))" variant="secondary">
                              <fa icon="info-circle"></fa>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </o-form-group>

                      <!--GX-->
                      <template v-if="fieldVisibility.turnoverGx">
                          <hr>
                          <o-input v-if="fieldVisibility.turnoverGx" :errorField="'turnoverGx'" :label="$t('sandoz.turnover_gx')" v-model.number="props.item.turnover_gx" type="number"/>
                      </template>
                      <template v-if="fieldVisibility.turnoverDevelopmentGx">
                          <o-input class="mb-0" :errorField="'turnover_gx_expectation'" :label="$t('sandoz.turnover_gx_expectation')" v-model.number="props.item.turnover_gx_expectation" type="number"/>
                      </template>

                      <o-form-group :label="$t('sandoz.discount_gx')" v-if="fieldVisibility.discountGx">
                          <b-container class="w-100 px-0">
                              <b-row>
                                  <b-col>
                                      <b-input-group append="%">
                                          <o-input-percentage-control v-model.number="props.item.discount_gx_percentage"
                                                                      :min="0.01" :max="99.99" :only-integer="false">
                                          </o-input-percentage-control>
                                      </b-input-group>
                                  </b-col>
                                  <b-col>
                                      <b-input-group prepend="CHF">
                                          <b-form-input v-model.number="props.item.discount_gx" type="number" :disabled="true"></b-form-input>
                                      </b-input-group>
                                  </b-col>
                              </b-row>
                          </b-container>
                      </o-form-group>

                      <o-form-group :label="$t('sandoz.discount_gx_variable')" v-if="fieldVisibility.discountGxVariable">
                          <b-container class="w-100 px-0">
                              <b-row>
                                  <b-col>
                                      <b-input-group append="%">
                                          <o-input-percentage-control v-model.number="props.item.discount_gx_variable_percentage"
                                                                      :min="0.01" :max="99.99" :only-integer="false">
                                          </o-input-percentage-control>
                                      </b-input-group>
                                  </b-col>
                                  <b-col>
                                      <b-input-group prepend="CHF">
                                          <b-form-input v-model.number="props.item.discount_gx_variable" type="number" :disabled="true"></b-form-input>
                                      </b-input-group>
                                  </b-col>
                              </b-row>
                          </b-container>
                      </o-form-group>

                      <o-form-group :label="$t('sandoz.marketing_activities_total_gx')" v-if="fieldVisibility.marketingActivitiesGx">
                          <b-container class="w-100 px-0">
                              <b-row>
                                  <b-col>
                                      <b-input-group append="%">
                                          <o-input-percentage-control v-model.number="props.item.marketing_activities_gx_percentage"
                                                                      :min="0.01" :max="99.99" :only-integer="false" :disabled="true">
                                          </o-input-percentage-control>
                                      </b-input-group>
                                  </b-col>
                                  <b-col>
                                      <b-input-group prepend="CHF">
                                          <b-form-input v-model.number="props.item.marketing_activities_gx" type="number"></b-form-input>
                                      </b-input-group>
                                  </b-col>
                              </b-row>
                          </b-container>
                      </o-form-group>

                      <div class="d-flex  align-items-center" v-if="fieldVisibility.advertisementGx || fieldVisibility.otherMarketingGx">
                          <div class="flex-fill">
                              <o-input v-if="fieldVisibility.advertisementGx" :errorField="'advertisement_gx'" :label="$t('sandoz.advertisement_gx')" v-model.number="props.item.advertisement_gx" type="number"/>
                              <o-input v-if="fieldVisibility.otherMarketingGx" class="mb-0" :errorField="'other_marketing_gx'" :label="$t('sandoz.other_marketing_gx')" v-model.number="props.item.other_marketing_gx" type="number"/>
                          </div>
                          <div class="ml-2">
                              <b-button v-b-modal.kamAdvertismentInfo size="sm" type="button"><fa icon="info-circle"></fa></b-button>
                          </div>
                        </div>

                      <!--OTC-->
                      <template v-if="fieldVisibility.turnoverOtc">
                          <hr>
                          <o-input :errorField="'turnoverOtc'" :label="$t('sandoz.turnover_otc')" v-model.number="props.item.turnover_otc" type="number"/>
                      </template>

                      <template v-if="fieldVisibility.turnoverDevelopmentOtc">
                          <o-input class="mb-0" :errorField="'turnover_otc_expectation'" :label="$t('sandoz.turnover_otc_expectation')" v-model.number="props.item.turnover_otc_expectation" type="number"/>
                      </template>

                      <o-form-group :label="$t('sandoz.discount_otc')" v-if="fieldVisibility.discountOtc">
                          <b-container class="w-100 px-0">
                              <b-row>
                                  <b-col>
                                      <b-input-group append="%">
                                          <o-input-percentage-control v-model.number="props.item.discount_otc_percentage"
                                                                      :min="0.01" :max="99.99" :only-integer="false">
                                          </o-input-percentage-control>
                                      </b-input-group>
                                  </b-col>
                                  <b-col>
                                      <b-input-group prepend="CHF">
                                          <b-form-input v-model.number="props.item.discount_otc" type="number" :disabled="true"></b-form-input>
                                      </b-input-group>
                                  </b-col>
                              </b-row>
                          </b-container>
                      </o-form-group>
                      <o-form-group :label="$t('sandoz.marketing_activities_total_otc')" v-if="fieldVisibility.marketingActivitiesOtc">
                          <b-container class="w-100 px-0">
                              <b-row>
                                  <b-col>
                                      <b-input-group append="%">
                                          <o-input-percentage-control v-model.number="props.item.marketing_activities_otc_percentage" :disabled="true"
                                                                      :min="0.01" :max="99.99" :only-integer="false">
                                          </o-input-percentage-control>
                                      </b-input-group>
                                  </b-col>
                                  <b-col>
                                      <b-input-group prepend="CHF">
                                          <b-form-input v-model.number="props.item.marketing_activities_otc" type="number"></b-form-input>
                                      </b-input-group>
                                  </b-col>
                              </b-row>
                          </b-container>
                      </o-form-group>

                      <div class="d-flex  align-items-center" v-if="fieldVisibility.advertisementOtc || fieldVisibility.otherMarketingOtc">
                          <div class="flex-fill">
                              <o-input v-if="fieldVisibility.advertisementOtc" :errorField="'advertisement_otc'" :label="$t('sandoz.advertisement_otc')" v-model.number="props.item.advertisement_otc" type="number"/>
                              <o-input v-if="fieldVisibility.otherMarketingOtc" :errorField="'other_marketing_otc'" :label="$t('sandoz.other_marketing_otc')" v-model.number="props.item.other_marketing_otc" type="number"/>
                          </div>
                          <div class="ml-2">
                              <b-button v-b-modal.kamAdvertismentInfo size="sm" type="button"><fa icon="info-circle"></fa></b-button>
                          </div>
                      </div>

                      <template v-if="fieldVisibility.marketingActivities">
                          <o-form-group :label="$t('sandoz.marketing_activities')" v-if="fieldVisibility.marketingActivities">
                              <b-container class="w-100 px-0">
                                  <b-row>
                                      <b-col>
                                          <b-input-group prepend="CHF">
                                              <b-form-input v-model.number="props.item.marketing_activities_gx" type="number"></b-form-input>
                                          </b-input-group>
                                      </b-col>
                                  </b-row>
                              </b-container>
                          </o-form-group>
                      </template>

                      <template v-if="fieldVisibility.turnoverDevelopment || fieldVisibility.turnoverDevelopmentOtc || fieldVisibility.turnoverDevelopmentGx">
                          <o-form-group label="" v-if="props.item.turnover_expectation">
                              <div class="w-100">
                                (
                                {{$t('sandoz.growth_forecast')}}
                                {{props.item.turnover_expectation - props.item.turnover | formatInteger}} /
                                {{(props.item.turnover_expectation / props.item.turnover - 1) * 100 | formatNumber}}%
                                )
                              </div>
                          </o-form-group>
                      </template>


                      <o-input v-if="fieldVisibility.contractValue" :label="$t('sandoz.contract_value')" v-model.number="props.item.marketing_activities" type="number"/>
                      <o-input v-if="fieldVisibility.contractDiscountValue" :label="$t('sandoz.contract_value')" v-model.number="props.item.discount" type="number"/>

                      <o-input v-if="fieldVisibility.advertisement" :errorField="'advertisement'" :label="$t('sandoz.advertisement')" v-model.number="props.item.advertisement" type="number"/>
                      <o-input v-if="fieldVisibility.otherMarketing" :errorField="'other_marketing'" :label="$t('sandoz.other_marketing')" v-model.number="props.item.other_marketing" type="number"/>
                  </b-col>
                  <b-col>
                      <o-datepicker :typeable="false" :errorField="'contract_start'" :label="$t('sandoz.contract_start')" v-model="props.item.contract_start"/>
                      <o-datepicker :typeable="false" :errorField="'contract_inhouse'" :label="$t('sandoz.contract_inhouse')" v-model="props.item.contract_inhouse"/>
                      <o-datepicker :typeable="false" :errorField="'contract_to_customer'" :label="$t('sandoz.contract_to_customer')" v-model="props.item.contract_to_customer"/>
                      <o-datepicker :typeable="false" :errorField="'contract_expiration'" :label="$t('sandoz.contract_expiration')" v-model="props.item.contract_expiration"/>
                      <o-datepicker :typeable="false" :errorField="'date_visit'" :label="$t('sandoz.date_visit')" v-model="props.item.date_visit"/>
                      <o-datepicker :typeable="false" :errorField="'conditions_start'" :label="$t('sandoz.conditions_start')" v-model="props.item.conditions_start"/>
                      <o-input :errorField="'invest_turnover'" :label="$t('sandoz.invest_turnover')" v-model="props.item.invest_turnover" type="number"/>
                      <o-input :errorField="'invest_turnover_forecast'" :label="$t('sandoz.invest_turnover_forecast')" v-model="props.item.invest_turnover_forecast" type="number"/>
                      <o-input :errorField="'invest_recommend'" :label="$t('sandoz.invest_recommend')" v-model="props.item.invest_recommend" type="number"/>
                      <o-input :errorField="'invest_recommend_percentage'" :label="$t('sandoz.invest_recommend_percentage')"
                              v-model="props.item.invest_recommend_percentage" type="number" format="percentage"
                              mask="XX.XXXX" append="%"/>
                      <o-input :errorField="'invest_max'" :label="$t('sandoz.invest_max')" v-model="props.item.invest_max" type="number"/>
                      <o-input :errorField="'invest_max_percentage'" :label="$t('sandoz.invest_max_percentage')"
                              v-model="props.item.invest_max_percentage" type="number" format="percentage"
                              mask="XX.XXXX" append="%"/>
                      <o-input :errorField="'total_costs'" :label="$t('sandoz.total_costs')" v-model="props.item.total_costs" type="number"/>
                      <o-input :errorField="'total_cost_percentage'" :label="$t('sandoz.total_cost_percentage')"
                              v-model="props.item.total_cost_percentage" type="number" format="percentage"
                              mask="XX.XXXX" append="%"/>

                      <o-input :errorField="'advertisement'" :label="$t('sandoz.advertisement')" v-model="props.item.advertisement" type="number"/>
                      <o-input :errorField="'other_marketing'" :label="$t('sandoz.other_marketing')" v-model="props.item.other_marketing" type="number"/>

                      <template  v-for="index in 6">
                        <o-form-group :label="$t('sandoz.approver_' + index)" :key="index" v-if="props.item['approver_' + index]">
                          <b-input-group :prepend="props.item['approver_' + index]">
                            <b-form-input readonly v-model="props.item['approval_person_' + index]"></b-form-input>
                            <b-input-group-append>
                              <b-input-group-text v-if="props.item['approval_date_' + index]">
                                {{props.item['approval_date_' + index] | formatDate}}
                              </b-input-group-text>
                              <o-delete method="delete" v-if="isRemoveable(index)"
                                        v-on:execute-action="removeApprover(index)">
                              </o-delete>
                            </b-input-group-append>
                          </b-input-group>
                        </o-form-group>
                      </template>

                      <o-form-group :label="$t('sandoz.next_approver')" v-if="props.item.next_approver_original && !props.item.is_approved">
                        <b-input-group class="mt-2 w-100">
                          <div class="pl-0 pr-0 font-weight-bold w-100">
                            {{ $t('sandoz.next_approver_users', {role: props.item.next_approver_original}) }}
                          </div>
                          <div class="row justify-content-start pb-1 pt-1 font-weight-bold ml-1 mr-1 mt-3 w-100">
                            <div class="col-sm pb-1 pl-0">
                              {{$t('core.name')}}
                            </div>
                            <div class="col-sm pb-1 pl-0 pr-0">
                              {{$t('core.email')}}
                            </div>
                            <div class="col-sm pb-1 pl-0 pr-0">
                              {{$t('core.phone')}}
                            </div>
                            <div class="col-sm pb-1 pl-0 pr-0">
                              {{$t('core.status')}}
                            </div>
                          </div>
                           <template v-if="props.item.next_approver_users && Object.keys(props.item.next_approver_users).length">
                            <div class="row justify-content-start border-top pb-1 pt-1 ml-1 mr-1 w-100" v-for="user in props.item.next_approver_users.filter(u => props.item.status !== 'Draft' || u.active)">
                              <div class="col-sm pb-1 pl-0">
                                {{ user.name }}
                              </div>
                              <div class="col-sm pb-1 pl-0 pr-0">
                                {{ user.email }}
                              </div>
                              <div class="col-sm pb-1 pl-0 pr-0">
                                {{ user.phone }}
                              </div>
                              <div class="col-sm pb-1 pl-0 pr-0">
                                <span class="badge" :class="user.active ? 'badge-success': 'badge-danger'">
                                    {{ user.active ? $t('core.active') : $t('core.inactive') }}
                                </span>
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <div class="row justify-content-start border-top pb-1 pt-1 ml-1 mr-1 w-100">
                              <div class="col-sm pb-1 pl-0">
                                {{ $t('sandoz.approver_not_found') }}
                              </div>
                            </div>
                          </template>
                        </b-input-group>
                      </o-form-group>

                      <o-input :errorField="'verification_percentage'" :label="$t('sandoz.verification_percentage')"
                              v-model="props.item.verification_percentage" type="number"
                              :description="$t('sandoz.verification_percentage_description')"/>

                      <o-form-group>
                        <div class="w-100">
                          <b-form-checkbox v-model="props.item.invoiceable" :value="true" :unchecked-value="false">{{$t('sandoz.invoiceable')}}</b-form-checkbox>
                          <b-form-checkbox v-model="props.item.invoicing_blocked" :value="true" :unchecked-value="false">{{$t('sandoz.invoicing_blocked')}}</b-form-checkbox>
                          <b-form-checkbox v-model="props.item.invoicing_finished" :value="true" :unchecked-value="false">{{$t('sandoz.invoicing_finished')}}</b-form-checkbox>
                        </div>
                      </o-form-group>
                  </b-col>
              </b-row>
            </b-collapse>
        </template>
        <template slot="child" slot-scope="props">
            <b-tabs>
                <b-tab :title="$t('sandoz.addresses')" active>
                    <o-card>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>{{$t('sandoz.address_id')}}</th>
                                    <th>{{$t('sandoz.address_type')}}</th>
                                    <th>{{$t('sandoz.name')}}</th>
                                    <th>{{$t('sandoz.last_name')}}</th>
                                    <th>{{$t('sandoz.company_name')}}</th>
                                    <th>{{$t('sandoz.street')}}</th>
                                    <th>{{$t('sandoz.zip')}}</th>
                                    <th>{{$t('sandoz.city')}}</th>
                                    <th>{{$t('sandoz.customer_no_xpris')}}</th>
                                    <th>{{$t('sandoz.customer_external_id')}}</th>
                                    <th>{{$t('sandoz.customer_external_id_hcp')}}</th>
                                    <th>{{$t('sandoz.customer_no_sap')}}</th>
                                    <th>{{$t('sandoz.customer_size')}}</th>
                                    <th>{{$t('sandoz.fte')}}</th>
                                    <th>{{$t('sandoz.phone_number')}}</th>
                                    <th class="text-right">
                                        <b-btn @click.prevent="open('addresses')" variant="primary">
                                            <fa icon="plus"/>
                                        </b-btn>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(address, i) in props.item.addresses">
                                    <td>{{address.id}}</td>
                                    <td>{{address.address_type}}</td>
                                    <td>{{address.name}}</td>
                                    <td>{{address.last_name}}</td>
                                    <td>{{address.company_name}}</td>
                                    <td>{{address.street}}</td>
                                    <td>{{address.zip}}</td>
                                    <td>{{address.city}}</td>
                                    <td>{{address.customer_no_xpris}}</td>
                                    <td>{{address.customer_external_id}}</td>
                                    <td>{{address.customer_external_id_hcp}}</td>
                                    <td>{{address.customer_no_sap}}</td>
                                    <td>{{address.customer_size}}</td>
                                    <td>{{address.fte}}</td>
                                    <td>{{address.phone_number}}</td>
                                    <td class="text-right text-nowrap">
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <b-btn @click.prevent="props.item.addresses.splice(i, 1)"
                                                   variant="secondary">
                                                <fa icon="times"/>
                                            </b-btn>
                                            <b-btn @click.prevent="open('addresses', i)" variant="primary">
                                                <fa icon="pencil-alt"/>
                                            </b-btn>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
                <b-tab :title="$t('sandoz.lines')"
                       :disabled="!props.item.lines || (props.item.lines && !props.item.lines.length)">
                    <o-card>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>{{$t('core.id')}}</th>
                                    <th>{{$t('sandoz.address_id')}}</th>
                                    <th>{{$t('sandoz.product')}}</th>
                                    <th>{{$t('sandoz.product_id')}}</th>
                                    <th>{{$t('sandoz.price')}}</th>
                                    <th>{{$t('sandoz.valid_from')}}</th>
                                    <th>{{$t('sandoz.valid_to')}}</th>
                                    <th>{{$t('sandoz.name')}}</th>
                                    <th>{{$t('sandoz.last_name')}}</th>
                                    <th>{{$t('sandoz.company_name')}}</th>
                                    <th>{{$t('sandoz.city')}}</th>
                                    <th>{{$t('core.note')}}</th>
                                    <th>{{$t('sandoz.adhoc')}}</th>
                                    <th class="text-right">
                                        <b-btn @click.prevent="open('lines')" variant="primary">
                                            <fa icon="plus"/>
                                        </b-btn>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(line, i) in props.item.lines">
                                    <td>{{line.id}}</td>
                                    <td>{{line.address_id}}</td>
                                    <td>{{line.product_name}}</td>
                                    <td>{{line.product ? line.product.product_id: ""}}</td>
                                    <td>{{line.price}}</td>
                                    <td>{{line.valid_from | formatDate}}</td>
                                    <td>{{line.valid_to | formatDate}}</td>
                                    <td>{{line.contract_address? line.contract_address.name : ""}}</td>
                                    <td>{{line.contract_address? line.contract_address.last_name : ""}}</td>
                                    <td>{{line.contract_address? line.contract_address.company_name : ""}}</td>
                                    <td>{{line.contract_address? line.contract_address.city : ""}}</td>
                                    <td>{{line.note}}</td>
                                    <td>{{ line.adhoc_item ? $t('sandoz.yes') : $t('sandoz.no')}}</td>
                                    <td class="text-right text-nowrap">
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <b-btn @click.prevent="props.item.lines.splice(i, 1)"
                                                   variant="secondary">
                                                <fa icon="times"/>
                                            </b-btn>
                                            <b-btn @click.prevent="open('lines', i)" variant="primary">
                                                <fa icon="pencil-alt"/>
                                            </b-btn>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
                <b-tab :title="$t('sandoz.attributes')"
                       :disabled="!props.item.lines || (props.item.lines && !props.item.lines.length)">
                    <o-card>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>{{$t('sandoz.line_id')}}</th>
                                    <th>{{$t('sandoz.attribute')}}</th>
                                    <th>{{$t('sandoz.value')}}</th>
                                    <th class="text-right">
                                        <b-btn @click.prevent="open('attributes')" variant="primary">
                                            <fa icon="plus"/>
                                        </b-btn>
                                    </th>
                                </tr>
                                </thead>
                                <tbody v-bind:key="line.id" v-for="(line, j) in props.item.lines">
                                <tr colspan="3" v-bind:key="attribute.id" v-for="(attribute, i) in line.attributes">
                                    <td>{{attribute.contract_line_id}}</td>
                                    <td>{{attribute.attribute}}</td>
                                    <td>{{attribute.value}}</td>
                                    <td class="text-right text-nowrap">
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <b-btn @click.prevent="props.item.lines[j].attributes.splice(i, 1)"
                                                   variant="secondary">
                                                <fa icon="times"/>
                                            </b-btn>
                                            <b-btn @click.prevent="open('attributes', i, j)" variant="primary">
                                                <fa icon="pencil-alt"/>
                                            </b-btn>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
                <b-tab :title="$t('sandoz.deliveries')"
                       :disabled="!props.item.lines || (props.item.lines &&!props.item.lines.length)">
                    <o-card>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>{{$t('sandoz.line_id')}}</th>
                                    <th>{{$t('sandoz.quantity')}}</th>
                                    <th>{{$t('sandoz.planned_delivery')}}</th>
                                    <th>{{$t('sandoz.product_name')}}</th>
                                    <th>{{$t('sandoz.exists')}}</th>
                                    <th>{{$t('sandoz.informed_date')}}</th>
                                    <th>{{$t('sandoz.delivery_executed')}}</th>
                                    <th>{{$t('sandoz.canceled_date')}}</th>
                                    <th>{{$t('core.note')}}</th>
                                    <th class="text-right">
                                        <b-btn @click.prevent="open('deliveries')" variant="primary">
                                            <fa icon="plus"/>
                                        </b-btn>
                                    </th>
                                </tr>
                                </thead>
                                <tbody v-bind:key="line.id" v-for="(line, j) in props.item.lines">
                                <tr colspan="3" v-bind:key="delivery.id" v-for="(delivery, i) in line.deliveries" :class="{'skip-delivery': delivery.skip_delivery}">
                                    <td>{{delivery.contract_line_id}}</td>
                                    <td>{{delivery.quantity}}</td>
                                    <td>
                                      {{ delivery.planned_delivery | formatDate }}
                                      <span v-if="delivery.skip_delivery" class="badge badge-warning" :title="delivery.planned_delivery">
                                        {{$t('sandoz.no_delivery_needed')}}
                                      </span>
                                    </td>
                                    <td>{{line.product_name}}</td>
                                    <td>
                                      {{line.attributes.find(a => a.attribute == 'exist') ? line.attributes.find(a => a.attribute == 'exist').value : ''}}
                                    </td>
                                    <td>{{delivery.informed_date | formatDate}}</td>
                                    <td>{{delivery.delivery_executed | formatDate}}</td>
                                    <td>{{delivery.canceled_date | formatDate}}</td>
                                    <td>{{delivery.note}}</td>
                                    <td class="text-right text-nowrap">
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <b-btn @click.prevent="props.item.lines[j].deliveries.splice(i, 1)"
                                                   variant="secondary">
                                                <fa icon="times"/>
                                            </b-btn>
                                            <b-btn @click.prevent="open('deliveries', i, j)" variant="primary">
                                                <fa icon="pencil-alt"/>
                                            </b-btn>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
                <b-tab :title="$t('sandoz.pdfs')"
                       :disabled="!props.item.pdfs || (props.item.pdfs && !props.item.pdfs.length)">
                    <o-card>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>{{$t('core.id')}}</th>
                                    <th>{{$t('core.user')}}</th>
                                    <th>{{$t('sandoz.file_name')}}</th>
                                    <th>{{$t('sandoz.date')}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(pdf, i) in props.item.pdfs">
                                    <td>{{pdf.id}}</td>
                                    <td>{{pdf.user? pdf.user.name : ""}}</td>
                                    <td>
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <o-button type="button" variant="primary"
                                                      @click.prevent="download(i)">
                                                <fa icon="file-pdf"/>
                                            </o-button>
                                        </div>
                                        {{pdf.file_name}}
                                    </td>
                                    <td>{{pdf.created_at | formatDate}}</td>
                                    <td class="text-right text-nowrap">
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <b-btn @click.prevent="props.item.pdfs.splice(i, 1)"
                                                   variant="secondary">
                                                <fa icon="times"/>
                                            </b-btn>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
                <b-tab :title="$t('sandoz.grid_files')"
                       :disabled="!props.item.import_jobs || (props.item.import_jobs && !props.item.import_jobs.length)">
                    <o-card>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>{{$t('core.id')}}</th>
                                    <th>{{$t('sandoz.file_name')}}</th>
                                    <th>{{$t('sandoz.date')}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(file, i) in props.item.import_jobs">
                                    <td>{{file.id}}</td>
                                    <td>
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <o-button type="button" variant="primary" @click.prevent="xlsx(i)">
                                                <fa icon="file-signature"/>
                                            </o-button>
                                        </div>
                                        {{file.file_name}}
                                    </td>
                                    <td>{{file.created_at | formatDate}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
                <b-tab :title="$t('sandoz.files')" :disabled="props.item.id === 'new'">
                    <o-card>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                  <th colspan="5" class="pdfFiles">
                                    <div class="float-right show-deleted-checkbox" v-if="props.item.id && props.item.id !== 'new' && (user && user.is_super_user)">
                                      <div class="w-100">
                                        <b-form-checkbox v-model="showDeletedFiles" value="true" @change="showDeleted">{{$t('sandoz.show_deleted_files')}}</b-form-checkbox>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                    <th>{{$t('core.id')}}</th>
                                    <th>{{$t('sandoz.file_name')}}</th>
                                    <th>{{$t('sandoz.user')}}</th>
                                    <th>{{$t('sandoz.date')}}</th>
                                    <th class="text-right">
                                        <b-btn @click.prevent="open('word_files')" variant="primary">
                                          <fa icon="plus"/>
                                        </b-btn>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(file, i) in props.item.word_files" :key="i" :class="file.deleted_at !== null && showDeletedFiles ? 'bg-disable' : ''">
                                    <td>{{file.id}}</td>
                                    <td>
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <o-button type="button" variant="primary" @click.prevent="word(i)">
                                                <template v-if="file.file_extension === 'docx' || file.file_extension === 'doc'">
                                                  <fa icon="file-word"/>
                                                </template>
                                                <template v-if="file.file_extension === 'xlsx' || file.file_extension === 'xlsx'">
                                                  <fa icon="file-excel"/>
                                                </template>
                                                <template v-if="file.file_extension === 'pdf'">
                                                  <fa icon="file-pdf"/>
                                                </template>
                                                <template v-if="file.file_extension === 'zip'">
                                                  <fa icon="file-zipper"/>
                                                </template>
                                                <template v-if="file.file_extension === 'png' || file.file_extension === 'jpeg' || file.file_extension === 'jpg'">
                                                  <fa icon="images"/>
                                                </template>
                                            </o-button>
                                        </div>
                                        {{file.file_name ? file.file_name.name: null}}
                                    </td>
                                    <td>{{file.user ? file.user.name: null}}</td>
                                    <td>{{file.created_at | formatDate}}</td>
                                    <td class="text-right text-nowrap">
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <b-btn @click.prevent="props.item.word_files.splice(i, 1)"
                                                   variant="secondary"  v-if="file.deleted_at === null">
                                              <fa icon="times"/>
                                            </b-btn>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
                <b-tab :title="$t('sandoz.kam_verifications')"
                       :disabled="!props.item.kam_verification_lines || (props.item.kam_verification_lines && !props.item.kam_verification_lines.length)">
                    <o-card>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>{{$t('sandoz.product_name')}}</th>
                                    <th>{{$t('sandoz.quantity')}}</th>
                                    <th>{{$t('sandoz.price')}}</th>
                                    <th>{{$t('sandoz.comment')}}</th>
                                    <th>{{$t('sandoz.disclosure')}}</th>
                                    <th>{{$t('sandoz.verification_date_1')}}</th>
                                    <th>{{$t('sandoz.verification_date_2')}}</th>
                                    <th>{{$t('sandoz.verification_date_3')}}</th>
                                    <th>{{$t('sandoz.verification_date_4')}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(kamVerification) in props.item.kam_verification_lines" :key="kamVerification.id">
                                    <td>{{kamVerification.product_name}}</td>
                                    <td>{{kamVerification.quantity}}</td>
                                    <td>{{kamVerification.price}}</td>
                                    <td>{{kamVerification.comment}}</td>
                                    <td>{{kamVerification.disclosure ? $t('sandoz.yes') : $t('sandoz.no')}}</td>
                                    <td>{{kamVerification.verification_date_1 | formatDate}}</td>
                                    <td>{{kamVerification.verification_date_2 | formatDate}}</td>
                                    <td>{{kamVerification.verification_date_3 | formatDate}}</td>
                                    <td>{{kamVerification.verification_date_4 | formatDate}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
                <b-tab :title="$t('sandoz.invoices')"
                       :disabled="!props.item.invoices || (props.item.invoices && !props.item.invoices.length)">
                  <o-card>
                    <div class="table-responsive">
                        <table class="table">
                          <thead>
                          <tr>
                            <th>{{$t('core.id')}}</th>
                            <th>{{$t('sandoz.date')}}</th>
                            <th>{{$t('sandoz.from')}}</th>
                            <th>{{$t('sandoz.to')}}</th>
                            <th></th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(invoice, i) in props.item.invoices" :key="invoice.id">
                            <td>#{{invoice.id}}</td>
                            <td>{{invoice.created_at | formatDate}}</td>
                            <td>{{invoice.start_month}}</td>
                            <td>{{invoice.end_month}}</td>
                            <td>
                              <o-button type="button" variant="primary" @click.prevent="downloadInvoice(invoice)">
                                <fa icon="file-pdf"/>
                              </o-button>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                    </div>
                  </o-card>
                </b-tab>
                <b-tab :title="$t('sandoz.access')"
                       :disabled="!props.item.access || (props.item.access && !props.item.access.length)">
                  <o-card>
                    <div class="table-responsive">
                        <table class="table">
                          <thead>
                          <tr>
                            <th>{{$t('sandoz.user')}}</th>
                            <th>{{$t('sandoz.access_source')}}</th>
                            <th class="text-right">
                              <b-btn @click.prevent="open('users')" variant="primary">
                                <fa icon="plus"/>
                              </b-btn>
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(access, i) in props.item.access" :key="access.id">
                            <td :title="access.id">{{access.user.name}}</td>
                            <td>{{access.access_source}}</td>
                            <td class="text-right text-nowrap">
                              <div aria-label="edit controls" class="btn-group btn-group-sm" role="group" v-if="access.access_source == 'manual'">
                                <b-btn @click.prevent="props.item.access.splice(i, 1)" variant="secondary">
                                  <fa icon="times"/>
                                </b-btn>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                    </div>
                  </o-card>
                </b-tab>
            </b-tabs>
            <b-modal :title="form ? $t('sandoz.' + form) : ''" @ok="close" id="modal-add-edit" ref="addEditModal" size="lg">
                <template v-if="form === 'lines'">
                    <o-value-select :label="$t('sandoz.product')" ref="productSelector"
                                    text-field="name_lang" url="/api/sandoz/products?sortBy=name" v-model="formSchema.lines.product_id"
                                    value-field="id">
                    </o-value-select>
                    <o-form-group :label="$t('sandoz.product_name')">
                        <div class="d-inline-block">
                            ( <b-form-checkbox class="d-inline-block" v-model="custom_product_name" :value="true"
                                              :unchecked-value="false">{{$t('sandoz.custom_name')}}
                            </b-form-checkbox> )
                        </div>
                        <input v-model="formSchema.lines.product_name" class="form-control" :readonly="!custom_product_name">
                    </o-form-group>
                    <o-input :label="$t('sandoz.price')" v-model="formSchema.lines.price"></o-input>
                    <o-value-select :label="$t('sandoz.address')" ref="addressSelector"
                                    :items="addresses" v-model="formSchema.lines.address_id">
                    </o-value-select>
                    <o-textarea :label="$t('core.note')" v-model="formSchema.lines.note"></o-textarea>

                    <o-datepicker :label="$t('sandoz.valid_from')" :typeable="false" v-model="formSchema.lines.valid_from"></o-datepicker>
                    <o-datepicker :label="$t('sandoz.valid_to')" :typeable="false" v-model="formSchema.lines.valid_to"></o-datepicker>
                </template>
                <template v-if="form === 'attributes'">
                    <o-value-select :items="props.item.lines" :label="$t('sandoz.line_id')"
                                    ref="productSelector" text-field="id"
                                    v-model="formSchema.attributes.contract_line_id"
                                    value-field="id">
                    </o-value-select>
                    <o-input :label="$t('sandoz.attribute')" v-model="formSchema.attributes.attribute"></o-input>
                    <o-input :label="$t('sandoz.value')" v-model="formSchema.attributes.value"></o-input>
                </template>
                <template v-if="form === 'deliveries'">
                    <o-value-select :items="props.item.lines" :label="$t('sandoz.line_id')"
                                    ref="productSelector" text-field="id"
                                    v-model="formSchema.deliveries.contract_line_id"
                                    value-field="id">
                    </o-value-select>
                    <o-input :label="$t('sandoz.quantity')" v-model="formSchema.deliveries.quantity"></o-input>
                    <o-datepicker :label="$t('sandoz.planned_delivery')" :typeable="false"
                                  v-model="formSchema.deliveries.planned_delivery" :initialTime="true"></o-datepicker>
                    <o-datepicker :label="$t('sandoz.informed_date')" :typeable="false"
                                v-model="formSchema.deliveries.informed_date"></o-datepicker>
                    <o-datepicker :label="$t('sandoz.delivery_executed')" :typeable="false"
                                  v-model="formSchema.deliveries.delivery_executed"></o-datepicker>
                    <o-datepicker :label="$t('sandoz.canceled_date')" :typeable="false"
                                  v-model="formSchema.deliveries.canceled_date"></o-datepicker>
                    <o-textarea :label="$t('core.note')" v-model="formSchema.deliveries.note"></o-textarea>
                    <o-checkbox :label="$t('sandoz.skip_delivery')"
                                v-model="formSchema.deliveries.skip_delivery"/>
                </template>
                <template v-if="form === 'invoices'">
                    <o-value-select :items="props.item.lines" :label="$t('sandoz.line_id')"
                                    ref="productSelector" text-field="id"
                                    v-model="formSchema.invoices.contract_line_id"
                                    value-field="id">
                    </o-value-select>
                    <o-value-select :items="paymentSchema" :label="$t('sandoz.payment_schema')"
                                    v-model="formSchema.invoices.payment_schema"/>
                    <o-datepicker :label="$t('sandoz.payment_due')" :typeable="false"
                                  v-model="formSchema.invoices.payment_due"></o-datepicker>
                    <o-datepicker :label="$t('sandoz.payment_executed')" :typeable="false"
                                  v-model="formSchema.invoices.payment_executed"></o-datepicker>
                </template>
                <template v-if="form === 'addresses'">
                    <o-input :label="$t('sandoz.del_address')" v-model="formSchema.addresses.del_address" type="number"></o-input>
                    <o-value-select :items="['master', 'delivery']" :label="$t('sandoz.address_type')"
                                    ref="addressTypeSelector" text-field="id"
                                    v-model="formSchema.addresses.address_type"
                                    value-field="id">
                    </o-value-select>
                    <o-input :label="$t('sandoz.customer_no_xpris')" v-model="formSchema.addresses.customer_no_xpris"></o-input>
                    <o-input :label="$t('sandoz.customer_external_id')" v-model="formSchema.addresses.customer_external_id"></o-input>
                    <o-input :label="$t('sandoz.customer_external_id_hcp')" v-model="formSchema.addresses.customer_external_id_hcp"></o-input>
                    <o-input :label="$t('sandoz.customer_no_sap')" v-model="formSchema.addresses.customer_no_sap"></o-input>
                    <o-input :label="$t('sandoz.salutation')" v-model="formSchema.addresses.salutation"></o-input>
                    <o-input :label="$t('sandoz.name')" v-model="formSchema.addresses.name"></o-input>
                    <o-input :label="$t('sandoz.last_name')" v-model="formSchema.addresses.last_name"></o-input>
                    <o-input :label="$t('sandoz.company_name')" v-model="formSchema.addresses.company_name"></o-input>
                    <o-input :label="$t('sandoz.street')" v-model="formSchema.addresses.street"></o-input>
                    <o-input :label="$t('sandoz.zip')" v-model="formSchema.addresses.zip"></o-input>
                    <o-input :label="$t('sandoz.city')" v-model="formSchema.addresses.city"></o-input>
                    <o-value-select :items="customerSizes" :label="$t('sandoz.customer_size')" value-field="id" text-field="customer_size" v-model="formSchema.addresses.customer_size"/>
                    <o-input :label="$t('sandoz.fte')" v-model="formSchema.addresses.fte"></o-input>
                    <o-input :label="$t('sandoz.phone_number')" v-model="formSchema.addresses.phone_number"></o-input>
                </template>
                <template v-if="form === 'users'">
                  <o-table url="/api/system/users?filter%5Bactive%5D=1%25" ref="userList" :custom-row-button="true" :enable-new="false" :shadow="false">
                      <template slot="filter">
                        <o-filter v-on:filter-updated="(filters) => $refs.userList.setFilters(filters)">
                          <o-filter-text :title="$t('core.name')" column="name"></o-filter-text>
                          <o-filter-text :title="$t('core.email')" column="email"></o-filter-text>
                        </o-filter>
                      </template>
                      <template slot="head">
                        <o-table-header column="name">{{$t('core.name')}}</o-table-header>
                        <o-table-header column="email">{{$t('core.email')}}</o-table-header>
                      </template>
                      <template slot="body" slot-scope="props">
                        <td>{{ props.item.name }}</td>
                        <td>{{ props.item.email }}</td>
                      </template>
                      <template slot="body-controls" slot-scope="props">
                        <td class="text-right">
                          <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                            <b-btn variant="secondary" @click="selectAccessUser(props.item)">
                              <fa icon="sign-in-alt"/>
                            </b-btn>
                          </div>
                        </td>
                      </template>
                    </o-table>
                </template>
                <template v-if="form === 'word_files'">
                    <o-file-upload v-model="formSchema.word_files.file_name" :allow-clear="true" :allow-download="true"
                                   accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </o-file-upload>
                </template>
            </b-modal>
            <b-modal id="modal-previous-contract" ref="addPreviousContractModel" :title="$t('sandoz.select_previous_contract')"
                     :ok-only="true" size="xl" :ok-title="$t('core.cancel')">
                <o-table url="/api/sandoz/contracts?include=master_address_single" title="" ref="previousContractList" :enable-new="false"
                         :enable-delete="false" :enable-edit="false" :shadow="false" :only-filterable="true">
                    <template slot="filter">
                        <o-filter v-on:filter-updated="(filters) => $refs.previousContractList.setFilters(filters)">
                            <o-filter-text :title="$t('sandoz.contract_no')" column="contract_no"></o-filter-text>
                            <o-filter-text :title="$t('sandoz.customer_external_id')" column="customer_external_id"></o-filter-text>
                            <o-filter-select :items="years" :title="$t('sandoz.contract_year')" column="contract_year"></o-filter-select>
                        </o-filter>
                    </template>
                    <template slot="head">
                        <o-table-header column="contract_no">{{$t('sandoz.contract_no')}}</o-table-header>
                        <o-table-header column="customer_external_id">{{$t('sandoz.customer_external_id')}}</o-table-header>
                        <o-table-header column="contract_year">{{$t('sandoz.contract_year')}}</o-table-header>
                        <o-table-header :sortable="false">{{$t('sandoz.name')}}</o-table-header>
                        <o-table-header :sortable="false">{{$t('sandoz.last_name')}}</o-table-header>
                        <o-table-header :sortable="false">{{$t('sandoz.company_name')}}</o-table-header>
                        <o-table-header :sortable="false">{{$t('sandoz.street')}}</o-table-header>
                        <o-table-header :sortable="false">{{$t('sandoz.zip')}}</o-table-header>
                        <o-table-header :sortable="false">{{$t('sandoz.city')}}</o-table-header>
                    </template>
                    <template slot="body" slot-scope="previousContractProps">
                        <td>{{ previousContractProps.item.contract_no }}</td>
                        <td>{{ previousContractProps.item.customer_external_id }}</td>
                        <td>{{ previousContractProps.item.contract_year }}</td>
                        <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                            previousContractProps.item.master_address_single.data.name : ''}}
                        </td>
                        <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                            previousContractProps.item.master_address_single.data.last_name : ''}}
                        </td>
                        <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                            previousContractProps.item.master_address_single.data.company_name : ''}}
                        </td>
                        <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                            previousContractProps.item.master_address_single.data.street : ''}}
                        </td>
                        <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                            previousContractProps.item.master_address_single.data.zip : ''}}
                        </td>
                        <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                            previousContractProps.item.master_address_single.data.city : ''}}
                        </td>
                    </template>
                    <template slot="body-controls" slot-scope="previousContractProps">
                        <td class="text-right">
                            <div v-if="previousContractProps.item.id === props.item.id">
                                <span class="badge badge-success">Current </span>
                            </div>
                            <div v-else-if="previousContractProps.item.id === props.item.previous_contract">
                                <span class="badge badge-warning">Previous</span>
                            </div>
                            <div v-else class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                                <b-btn variant="primary" @click="addPreviousContract(previousContractProps.item)">
                                    <fa icon="arrow-right"/>
                                </b-btn>
                            </div>
                        </td>
                    </template>
                </o-table>
            </b-modal>

            <b-modal ref="statusChangesModal" :title="$t('sandoz.status_changes')">
                <div class="table-responsive table-bordered">
                  <table class="table table-sm">
                    <tbody>
                      <tr v-for="revisionHistory in statusChanges" :key="revisionHistory.id">
                        <td>{{revisionHistory.new_value}}</td>
                        <td>{{revisionHistory.created_at | formatDate}}</td>
                        <td>{{revisionHistory.user_responsible.name}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            </b-modal>

            <b-modal id="kamAdvertismentInfo" ok-only :title="$t('sandoz.marketing_split')">
              <p v-html="$t('sandoz.marketing_split_text')"/>
            </b-modal>

            <b-modal id="linkKukoModal" ref="linkKukoModal" :title="$t('sandoz.link_kuko')" hide-footer @show="kukoSearch = ''" size="lg">
                <div class="mb-3">
                    <div class="input-group">
                        <input type="text" class="form-control" v-model="kukoSearch" :placeholder="$t('sandoz.kuko_id')" @keyup.enter="fetchKukos(true)">
                        <div class="input-group-append">
                            <b-button variant="primary" @click="fetchKukos(true)">
                                <fa icon="search"/>
                            </b-button>
                        </div>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>{{ $t('sandoz.kuko_id') }}</th>
                                <th>{{ $t('sandoz.status') }}</th>
                                <th>{{ $t('sandoz.date') }}</th>
                                <th class="text-right"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="kuko in availableKukos" :key="kuko.id">
                                <td class="align-middle">
                                    {{ kuko.id }}
                                    <span v-if="kuko.contracts && kuko.contracts.length" class="small text-danger ml-1">
                                        ({{ $t('sandoz.kuko_connected_to_contract', {id: kuko.contracts[0].id}) }})
                                    </span>
                                </td>
                                <td class="align-middle">{{ kuko.status }}</td>
                                <td class="align-middle">{{ kuko.kuko_date | formatDate }}</td>
                                <td class="text-right align-middle">
                                    <b-button size="sm" variant="primary" @click="linkKuko(kuko.id)">
                                        {{ $t('sandoz.link') }}
                                    </b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-modal>
        </template>
    </o-form>
</template>

<script>
  import axios from 'axios'
  import {mapGetters} from 'vuex'
  import TemplateDownloadButton from './partials/TemplateDownloadButton.vue'
  import contractYearMixin from '../../mixins/contractYearMixin'

  export default {
    mixins: [contractYearMixin],
    components: {
      TemplateDownloadButton
    },
    data: () => ({
      paymentSchema: [],
      form: null,
      formSchema: {},
      i: null,
      j: null,
      detailOpen: false,
      status: [],
      addresses: [],
      types: [],
      customerSizes: [],
      custom_product_name: false,
      currency_symbol: window.config.currency_symbol,
      years: [],
      statusChanges: null,
      showDeletedFiles: false,
      fieldVisibility: {
        otherMarketing: false,
        advertisement: false,
        turnover: false,
        turnoverDevelopment: false,
        discount: false,
        marketingActivities: false,
        contractValue: false,
        contractDiscountValue: false,
        turnoverGx: false,
        turnoverOtc: false,
        turnoverDevelopmentGx: false,
        turnoverDevelopmentOtc: false,
        discountGx: false,
        discountGxVariable: false,
        discountOtc: false,
        marketingActivitiesGx: false,
        marketingActivitiesOtc: false,
        advertisementGx: false,
        otherMarketingGx: false,
        advertisementOtc: false,
        otherMarketingOtc: false
      },
      regions: [],
      availableKukos: [],
      kukoSearch: ''
    }),
    computed: {
      ...mapGetters({
        user: 'auth/user'
      }),
      filteredTypes() {
        if (this.$route.params.id === 'new') {
          return this.types.filter(type => !type.value.endsWith('_KUKO'));
        }
        return this.types;
      }
    },
    created() {
      this.updateContractYears()

      this.paymentSchema = [
        {value: 'quarter', text: this.$i18n.t('sandoz.quarter')},
        {value: 'semester', text: this.$i18n.t('sandoz.semester')},
        {value: 'yearly', text: this.$i18n.t('sandoz.yearly')}
      ]
      this.status = [
        {value: 'Draft', text: this.$i18n.t('sandoz.draft')},
        {value: 'Planned', text: this.$i18n.t('sandoz.planned')},
        {value: 'Committed', text: this.$i18n.t('sandoz.committed')},
        {value: 'Signed', text: this.$i18n.t('sandoz.signed')},
        {value: 'Lost', text: this.$i18n.t('sandoz.lost')},
        {value: 'Cancelled', text: this.$i18n.t('sandoz.cancelled')},
        {value: 'ZeroInvest', text: this.$i18n.t('sandoz.zero_invest')},
        {value: 'Feedback', text: this.$i18n.t('sandoz.feedback')},
        {value: 'Rejected', text: this.$i18n.t('sandoz.rejected')},
        {value: 'Approved', text: this.$i18n.t('sandoz.approved')},
        {value: 'Invoice Release Pending', text: this.$i18n.t('sandoz.invoice_release_pending')}
      ]
      this.types = [
        {value: 'APO', text: this.$i18n.t('sandoz.apo')},
        {value: 'APO_ONE', text: this.$i18n.t('sandoz.apo_one')},
        {value: 'CNS', text: this.$i18n.t('sandoz.cns')},
        {value: 'HEIM', text: this.$i18n.t('sandoz.heim')},
        {value: 'IMMUNO', text: this.$i18n.t('sandoz.immuno')},
        {value: 'KAM_APO', text: this.$i18n.t('sandoz.kam_apo')},
        {value: 'KAM_HOSP', text: this.$i18n.t('sandoz.kam_hosp')},
        {value: 'KAM_SD', text: this.$i18n.t('sandoz.kam_sd')},
        {value: 'KAM_WHS', text: this.$i18n.t('sandoz.kam_whs')},
        {value: 'KAM_DIVERSE', text: this.$i18n.t('sandoz.kam_diverse')},
        {value: 'KAM_DIVERSE_HOSP', text: this.$i18n.t('sandoz.kam_diverse_hosp')},
        {value: 'KAM_DIVERSE_INSUR', text: this.$i18n.t('sandoz.kam_diverse_insur')},
        {value: 'ONCO', text: this.$i18n.t('sandoz.onco')},
        {value: 'OTC', text: this.$i18n.t('sandoz.otc')},
        {value: 'SD', text: this.$i18n.t('sandoz.sd')},
        {value: 'SD_GADGET', text: this.$i18n.t('sandoz.sd_gadget')},
        {value: 'CNS_GADGET', text: this.$i18n.t('sandoz.cns_gadget')},
        {value: 'IMMUNO_GADGET', text: this.$i18n.t('sandoz.immuno_gadget')},
        {value: 'KAM_SD_GADGET', text: this.$i18n.t('sandoz.kam_sd_gadget')},
        {value: 'APO_GADGET', text: this.$i18n.t('sandoz.apo_gadget')},
        {value: 'KAM_APO_GADGET', text: this.$i18n.t('sandoz.kam_apo_gadget')},
        {value: 'SD_EDU', text: this.$i18n.t('sandoz.sd_edu')},
        {value: 'CNS_EDU', text: this.$i18n.t('sandoz.cns_edu')},
        {value: 'IMMUNO_EDU', text: this.$i18n.t('sandoz.immuno_edu')},
        {value: 'ONCO_EDU', text: this.$i18n.t('sandoz.onco_edu')},
        {value: 'KAM_SD_EDU', text: this.$i18n.t('sandoz.kam_sd_edu')},
        {value: 'APO_EDU', text: this.$i18n.t('sandoz.apo_edu')},
        {value: 'KAM_APO_EDU', text: this.$i18n.t('sandoz.kam_apo_edu')},
        {value: 'SD_SORTALYS', text: this.$i18n.t('sandoz.sd_sortlays')},
        {value: 'CNS_SORTALYS', text: this.$i18n.t('sandoz.cns_sortlays')},
        {value: 'ONCO_SORTALYS', text: this.$i18n.t('sandoz.onco_sortlays')},
        {value: 'IMMUNO_SORTALYS', text: this.$i18n.t('sandoz.immuno_sortlays')},
        {value: 'KAM_SD_SORTALYS', text: this.$i18n.t('sandoz.kam_sd_sortlays')},
        {value: 'PV', text: this.$i18n.t('sandoz.pv')},
        {value: 'BIOS_APO', text: this.$i18n.t('sandoz.bios_apo')},
        {value: 'HIGHSPEC_GADGET', text: this.$i18n.t('sandoz.highspec_gadget')},
        {value: 'BIOS_KAM_APO', text: this.$i18n.t('sandoz.bios_kam_apo')},
        {value: 'BIOS_KAM_WHS', text: this.$i18n.t('sandoz.bios_kam_whs')},
        {value: 'HIGHSPEC_SORTALYS', text: this.$i18n.t('sandoz.highspec_sortalys')},
        {value: 'APO_OTC', text: this.$i18n.t('sandoz.apo_otc')},
        {value: 'APO_KUKO', text: this.$i18n.t('sandoz.apo_kuko')},
        {value: 'SD_KUKO', text: this.$i18n.t('sandoz.sd_kuko')},
        {value: 'IMMUNO_KUKO', text: this.$i18n.t('sandoz.immuno_kuko')},
        {value: 'HOSP_KUKO', text: this.$i18n.t('sandoz.hosp_kuko')},
        {value: 'CNS_KUKO', text: this.$i18n.t('sandoz.cns_kuko')},
      ]

      this.contractTypes = [
        {
          value: 'KAM_APO',
          text: this.$i18n.t('sandoz.kam_apo'),
          fields: {
            otherMarketing: false,
            advertisement: false,
            turnover: false,
            turnoverDevelopment: false,
            discount: false,
            marketingActivities: false,
            contractValue: false,
            contractDiscountValue: false,
            turnoverGx: true,
            turnoverOtc: true,
            turnoverDevelopmentGx: true,
            turnoverDevelopmentOtc: true,
            discountGx: true,
            discountGxVariable: false,
            discountOtc: true,
            marketingActivitiesGx: true,
            marketingActivitiesOtc: true,
            advertisementGx: true,
            otherMarketingGx: true,
            advertisementOtc: true,
            otherMarketingOtc: true
          }
        },
        {
          value: 'KAM_SD',
          text: this.$i18n.t('sandoz.kam_sd'),
          fields: {
            otherMarketing: false,
            advertisement: false,
            turnover: false,
            turnoverDevelopment: false,
            discount: false,
            marketingActivities: false,
            contractValue: false,
            contractDiscountValue: false,
            turnoverGx: true,
            turnoverOtc: true,
            turnoverDevelopmentGx: true,
            turnoverDevelopmentOtc: true,
            discountGx: true,
            discountGxVariable: false,
            discountOtc: true,
            marketingActivitiesGx: true,
            marketingActivitiesOtc: true,
            advertisementGx: true,
            otherMarketingGx: true,
            advertisementOtc: true,
            otherMarketingOtc: true
          }
        },
        {
          value: 'KAM_WHS',
          text: this.$i18n.t('sandoz.kam_whs'),
          fields: {
            otherMarketing: false,
            advertisement: false,
            turnover: false,
            turnoverDevelopment: false,
            discount: false,
            marketingActivities: false,
            contractValue: false,
            contractDiscountValue: false,
            turnoverGx: true,
            turnoverOtc: true,
            turnoverDevelopmentGx: true,
            turnoverDevelopmentOtc: true,
            discountGx: true,
            discountGxVariable: true,
            discountOtc: true,
            marketingActivitiesGx: true,
            marketingActivitiesOtc: true,
            advertisementGx: true,
            otherMarketingGx: true,
            advertisementOtc: true,
            otherMarketingOtc: true
          }
        },
        {
          value: 'KAM_DIVERSE_HOSP',
          text: this.$i18n.t('sandoz.kam_diverse_hosp'),
          fields: {
            otherMarketing: false,
            advertisement: false,
            turnover: false,
            turnoverDevelopment: false,
            discount: false,
            marketingActivities: false,
            contractValue: false,
            contractDiscountValue: true,
            turnoverGx: false,
            turnoverOtc: false,
            turnoverDevelopmentGx: false,
            turnoverDevelopmentOtc: false,
            discountGx: false,
            discountGxVariable: false,
            discountOtc: false,
            marketingActivitiesGx: false,
            marketingActivitiesOtc: false,
            advertisementGx: false,
            otherMarketingGx: false,
            advertisementOtc: false,
            otherMarketingOtc: false
          }
        },
        {
          value: 'KAM_DIVERSE_INSUR',
          text: this.$i18n.t('sandoz.kam_diverse_insur'),
          fields: {
            otherMarketing: false,
            advertisement: false,
            turnover: false,
            turnoverDevelopment: false,
            discount: false,
            marketingActivities: false,
            checkboxMultiYearContract: true,
            checkboxDeliveryRequired: false,
            checkboxAvailableMarketingItems: false,
            checkboxDisclosureRequirement: false,
            note: true,
            contractValue: true,
            contractDiscountValue: false,
            turnoverGx: false,
            turnoverOtc: false,
            turnoverDevelopmentGx: false,
            turnoverDevelopmentOtc: false,
            discountGx: false,
            discountGxVariable: false,
            discountOtc: false,
            marketingActivitiesGx: false,
            marketingActivitiesOtc: false,
            advertisementGx: false,
            otherMarketingGx: false,
            advertisementOtc: false,
            otherMarketingOtc: false
          }
        },
        {
          value: 'KAM_SD_SORTALYS',
          text: this.$i18n.t('sandoz.kam_sd_sortlays'),
          fields: {
            otherMarketing: false,
            advertisement: false,
            turnover: false,
            turnoverDevelopment: false,
            discount: false,
            marketingActivities: true,
            checkboxMultiYearContract: false,
            checkboxDeliveryRequired: false,
            checkboxAvailableMarketingItems: false,
            checkboxDisclosureRequirement: false,
            note: false,
            contractValue: false,
            contractDiscountValue: false,
            turnoverGx: false,
            turnoverOtc: false,
            turnoverDevelopmentGx: false,
            turnoverDevelopmentOtc: false,
            discountGx: false,
            discountGxVariable: false,
            discountOtc: false,
            marketingActivitiesGx: false,
            marketingActivitiesOtc: false,
            advertisementGx: false,
            otherMarketingGx: false,
            advertisementOtc: false,
            otherMarketingOtc: false
          }
        },
      ]
    },
    mounted() {
        axios('/api/sandoz/customer_sizes', {params: {per_page: Number.MAX_SAFE_INTEGER}}).then((response) => {
            this.customerSizes = response.data.data
        })
        .catch((error) => {
            console.log(error)
        })
        this.loadRegions()
    },
    methods: {
      openKuko(id) {
        this.$router.push({ path: '/kukos/' + id })
      },
      fetchKukos(isSearch = false) {
        this.$root.$loading.start()
        axios.get('/api/sandoz/contracts/' + this.$route.params.id + '/kukos', {
          params: { search: isSearch ? this.kukoSearch : null }
        })
          .then((response) => {
            this.availableKukos = response.data
            if (!isSearch) {
              this.$refs.linkKukoModal.show()
            }
            this.$root.$loading.finish()
          }).catch((error) => {
            this.$root.$loading.finish()
            console.log(error)
          })
      },
      linkKuko(kukoId) {
        this.$root.$loading.start()
        axios.post('/api/sandoz/contracts/' + this.$route.params.id + '/link-kuko', {
          kuko_id: kukoId
        })
          .then((response) => {
            if (!this.$refs.form.item.kukos) {
              this.$set(this.$refs.form.item, 'kukos', [])
            }
            if (!this.$refs.form.item.kukos.find(k => k.id === kukoId)) {
              this.$refs.form.item.kukos.push({ id: kukoId })
            }
            this.$set(this.$refs.form.item, 'kuko_link', kukoId)
            this.$refs.linkKukoModal.hide()
            this.$root.$loading.finish()
            this.$bvToast.toast(this.$t('sandoz.kuko_linked'), { variant: 'success' })
          }).catch((error) => {
            this.$root.$loading.finish()
            console.log(error)
          })
      },
      unlinkKukoConfirm(kukoId = null) {
        this.$bvModal.msgBoxConfirm(this.$t('sandoz.unlink_kuko_confirm'), {
          title: this.$t('sandoz.confirmation'),
          okVariant: 'danger',
          okTitle: this.$t('core.yes'),
          cancelTitle: this.$t('core.no'),
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {
            if (value) {
              this.unlinkKuko(kukoId)
            }
          })
      },
      unlinkKuko(kukoId = null) {
        this.$root.$loading.start()
        axios.post('/api/sandoz/contracts/' + this.$route.params.id + '/unlink-kuko', {
          kuko_id: kukoId
        })
          .then((response) => {
            if (kukoId) {
              if (this.$refs.form.item.kukos) {
                this.$refs.form.item.kukos = this.$refs.form.item.kukos.filter(k => k.id !== kukoId)
              }
              if (this.$refs.form.item.kuko_link == kukoId) {
                const nextKukoId = this.$refs.form.item.kukos && this.$refs.form.item.kukos.length > 0 ? this.$refs.form.item.kukos[0].id : null
                this.$set(this.$refs.form.item, 'kuko_link', nextKukoId)
                this.$set(this.$refs.form.item, 'kuko_id', nextKukoId)
              }
            } else {
              this.$set(this.$refs.form.item, 'kukos', [])
              this.$set(this.$refs.form.item, 'kuko_link', null)
              this.$set(this.$refs.form.item, 'kuko_id', null)
            }
            this.$root.$loading.finish()
            this.$bvToast.toast(this.$t('sandoz.kuko_unlinked'), { variant: 'success' })
          }).catch((error) => {
            this.$root.$loading.finish()
            console.log(error)
          })
      },
      loaded(item) {
        this.updateContractYears()
        this.setFieldVisibility(item)
      },
      showStatusChanges(item) {
        axios.get(`/api/sandoz/contracts/${item.id}/status-changes`).then(response => {
          this.statusChanges = response.data.revision_history
          this.$refs.statusChangesModal.show()
        })
      },
      open(type, i = null, j = null) {
        this.reset()

        this.form = type;
        this.i = i;
        this.j = j;
        this.address()

        if (this.i !== null && this.j === null) {
          this.formSchema[this.form] = Object.assign({},
            this.formSchema[this.form], this.$refs.form.item[this.form][this.i]
          )

          if(this.form === 'lines' &&
            this.formSchema[this.form].product &&
            this.formSchema[this.form].product.name_lang.trim() !== this.formSchema[this.form].product_name.trim())
          {
            this.custom_product_name = true
          }
        } else if (this.j !== null && this.form === 'lines') {
          this.formSchema[this.form] = Object.assign({},
            this.formSchema[this.form], this.$refs.form.item.lines[this.j][this.form][this.i]
          )
        } else if (this.j !== null && this.form === 'addresses') {
          this.formSchema[this.form] = Object.assign({},
            this.formSchema[this.form], this.$refs.form.item.addresses[this.j][this.form][this.i]
          )
        } else if(this.i !== null && this.j !== null) {
          this.formSchema[this.form] = Object.assign({},
            this.formSchema[this.form], this.$refs.form.item.lines[this.j][this.form][this.i]
          )
        }
        this.$refs.addEditModal.show()
      },
      close() {
        let $self = this;
        if ($self.i === null && $self.j === null) {
          if ($self.j === null && $self.form === 'lines') {
            let options = $self.$refs.productSelector.$el.querySelector('select').options
            let addressOptions = $self.$refs.addressSelector.$el.querySelector('select').options

            if(options.selectedIndex !== -1 && addressOptions.selectedIndex !== -1) {
              let productName = options[options.selectedIndex].textContent;
              $self.formSchema[$self.form].product = {
                id: $self.formSchema[$self.form].product_id,
                name: productName
              }

              $self.addresses.forEach(function (item, i) {
                if(item.value === $self.formSchema[$self.form].address_id) {
                  $self.formSchema[$self.form].contract_address = Object.assign({},
                    $self.formSchema[$self.form].contract_address, item
                  )
                  return true
                }
              })

              const length = $self.$refs.form.item[$self.form].length
              if($self.formSchema[$self.form].hasOwnProperty('id')) {
                delete $self.formSchema[$self.form].id
              }
              $self.$set($self.$refs.form.item[$self.form], [length], $self.formSchema[$self.form])
            }
          } else if ($self.j === null && $self.form === 'addresses') {
            const length = $self.$refs.form.item[$self.form].length
            if ($self.formSchema[$self.form].hasOwnProperty('id')) {
              delete $self.formSchema[$self.form].id
            }
            $self.$set($self.$refs.form.item[$self.form], [length], $self.formSchema[$self.form])
          } else if ($self.form === 'word_files') {
            console.log($self.formSchema[$self.form])
            $self.$refs.form.item[$self.form].push($self.formSchema[$self.form])
          } else {
            $self.$refs.form.item.lines.forEach(function (item, i) {
              if (item.id === $self.formSchema[$self.form].contract_line_id) {
                const length = $self.$refs.form.item.lines[i][$self.form].length
                if($self.$refs.form.item.lines[i][$self.form].hasOwnProperty('id')) {
                  delete $self.$refs.form.item.lines[i][$self.form].id
                }
                $self.$set($self.$refs.form.item.lines[i][$self.form], [length], $self.formSchema[$self.form])
                return true
              }
            })
          }
        } else {
          if ($self.j === null && $self.form === 'lines') {
            let options = $self.$refs.productSelector.$el.querySelector('select').options
            let addressOptions = $self.$refs.addressSelector.$el.querySelector('select').options

            if(options.selectedIndex !== -1 && addressOptions.selectedIndex !== -1) {
              let productName = options[options.selectedIndex].textContent
              $self.formSchema[$self.form].product = {
                id: $self.formSchema[$self.form].product_id,
                name: productName
              }

              $self.addresses.forEach(function (item, i) {
                if(item.value === $self.formSchema[$self.form].address_id) {
                  $self.formSchema[$self.form].contract_address = Object.assign({},
                    $self.formSchema[$self.form].contract_address, item
                  )
                  return true
                }
              })
              $self.$set($self.$refs.form.item[$self.form], [$self.i], $self.formSchema[$self.form])
            }
          } else if ($self.j === null && $self.form === 'addresses') {
            $self.$set($self.$refs.form.item[$self.form], [$self.i], $self.formSchema[$self.form])
          } else {
            $self.$set($self.$refs.form.item.lines[$self.j][$self.form], [$self.i], $self.formSchema[$self.form])
          }
        }
        $self.$refs.addEditModal.hide()
      },
      download (i = null) {
        if (i !== null) {
          let pdf = this.$refs.form.item.pdfs[i]
          axios.post('/api/sandoz/contract_pdfs/download', {
            'id': pdf.id
          }, { responseType: 'arraybuffer' })
            .then((response) => {
              require('downloadjs')(response.data,
                pdf.file_name + '.pdf', 'application/pdf'
              )
            }).catch((error) => {
            console.log(error)
          })
        }
      },
      downloadInvoice(invoice) {
          axios.post('/api/sandoz/contract_invoice_pdfs/download', {
            'id': invoice.id
          }, { responseType: 'arraybuffer' })
            .then((response) => {
              require('downloadjs')(response.data,
                'invoice_' + invoice.id + '.pdf', 'application/pdf'
              )
            }).catch((error) => {
            console.log(error)
          })
      },
      address() {
        let $self = this;
        $self.addresses = []
        axios
          .get('/api/sandoz/contracts/' + $self.$route.params.id + '?include=addresses', {
            params: {per_page: Number.MAX_SAFE_INTEGER}
          })
          .then((response) => {
            if(response.data.addresses) {
              response.data.addresses.forEach(function (item) {
                $self.addresses.push({
                  value: item.id,
                  text: item.name + ' ' + item.last_name + ' ( ' + item.company_name + ' - ' + item.city + ' )',
                  name: item.name,
                  last_name: item.last_name,
                  company_name: item.company_name,
                  city: item.city
                })
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      reset () {
        this.formSchema = Object.assign({}, this.formSchema, {
          lines: {
            'contract_id': null,
            'product_id': null,
            'price': null,
            'quantity': null,
            'note': null,
            'product_name': null
          },
          attributes: {
            'contract_line_id': null,
            'attribute': null,
            'value': null
          },
          deliveries: {
            'contract_line_id': null,
            'quantity': null,
            'planned_delivery': null,
            'delivery_executed': null,
            'note': null
          },
          invoices: {
            'contract_line_id': null,
            'payment_schema': null,
            'payment_due': null,
            'payment_executed': null
          },
          addresses: {
            'contract_id': null,
            'del_address': null,
            'salutation': null,
            'name': null,
            'last_name': null,
            'company_name': null,
            'street': null,
            'zip': null,
            'city': null,
            'customer_size': null,
            'fte': null
          },
          word_files: {
            'contract_id': this.$route.params.id,
            'user': this.user,
            'user_id': this.user.id,
            'file_name': {}
          }
        })
        this.i = null
        this.j = null
        this.form = null
        this.custom_product_name = false
      },
      xlsx (i) {
        if (i !== null) {
          let file = this.$refs.form.item.import_jobs[i]
          axios.post('/api/sandoz/import_jobs/download', {
            'id': file.id
          }, {responseType: 'arraybuffer'})
            .then((response) => {
              require('downloadjs')(response.data,
                file.file_name, 'application/vnd.ms-excel'
              )
            }).catch((error) => {
            console.log(error)
          })
        }
      },
      word (i) {
        if (i !== null) {
          const file = this.$refs.form.item.word_files[i]
          console.log(file)
          axios.post('/api/sandoz/contract_word_file/download', {
            'id': file.id
          }, {responseType: 'arraybuffer'})
              .then((response) => {
                require('downloadjs')(
                    response.data,
                    file.file_name.name,
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                )
              }).catch((error) => {
            console.log(error)
          })
        }
      },
      vendorForm () {
        this.$root.$loading.start()
        axios.get('/api/sandoz/contracts/' + this.$route.params.id + '/vendor-form',
            { responseType: 'arraybuffer' })
          .then((response) => {
            require('downloadjs')(
                response.data,
                'vendor_form_' + this.$route.params.id + '.docx',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            )
            this.$root.$loading.finish()
          }).catch((error) => {
            this.$root.$loading.finish()
            console.log(error)
          })
      },
      pdfContract() {
        this.$root.$loading.start()
        axios.post('/api/sandoz/generate-pdf2', {id:this.$route.params.id}, { responseType: 'arraybuffer' })
          .then((response) => {
            require('downloadjs')(
                response.data,
                'contract_' + this.$route.params.id + '.pdf',
                'application/pdf'
            )
            this.$root.$loading.finish()
          }).catch((error) => {
            this.$root.$loading.finish()
            console.log(error)
          })
      },
      addPreviousContract (contract) {
        this.$set(this.$refs.form.item, 'previous_contract', contract.id)
        this.$set(this.$refs.form.item, 'previous', contract)
        this.$set(this.$refs.form.item, 'no_previous_contract', false)
        this.$refs.addPreviousContractModel.hide()
      },
      selectAccessUser(access) {
        this.$refs.form.item.access.push({
          'contract_id': this.$refs.form.item.id,
          'user_id': access.id,
          'access_source': 'manual',
          'user': access
        })
        this.$refs.addEditModal.hide()
      },
      removeApprover(index) {
        this.$refs.form.item['approval_person_' + index] = null
        this.$refs.form.item['approval_date_' + index] = null
        this.$refs.form.item['next_approver'] = index > 1 ? index : null
        this.$refs.form.item['next_approver_role'] = this.$refs.form.item['approver_' + index]
        this.$refs.form.item['next_approver_original'] = this.$refs.form.item['approver_' + index]
        this.$refs.form.item['status'] = 'Committed'
        this.$refs.form.item['is_approved'] = false
        this.nextApproverDetails(this.$refs.form.item['approver_' + index])
      },
      nextApproverDetails (role) {
        axios.get('/api/sandoz/contracts/next_approver_users/' + this.$route.params.id + '/' + role)
          .then((response) => {
            this.$set(this.$refs.form.item, 'next_approver_users', response.data)
          }).catch((error) => {
          console.log(error)
        })
      },
      isRemoveable (index) {
        if(this.user && !this.user.is_super_user) {
          return false
        }

        let i
        let approver = 0
        for (i = 1; i <= 6; i++) {
          if(this.$refs.form.item['approval_person_' + i] && this.$refs.form.item['approval_date_' + i]) {
            approver++
          }
        }

        return index === approver
      },
      showDeleted() {
        let url = '/api/contractDeletedFiles?show_deleted='+this.showDeletedFiles+'&contract_id='+this.$route.params.id
        axios
          .get(url)
          .then((response) => {
            this.$refs.form.item.word_files = response.data.word_files
        })
      },
      setFieldVisibility(item) {
        if (!item) {
          return
        }
        this.handleTypeChange(item.type)

        this.$nextTick(function (){
          const fieldVisibility = this.contractTypes.find(c => c.value == item.type)
          if(fieldVisibility) {
            this.fieldVisibility = fieldVisibility.fields
          } else {
            this.fieldVisibility = {
              otherMarketing: false,
              advertisement: false,
              turnover: false,
              turnoverDevelopment: false,
              discount: false,
              marketingActivities: false,
              contractValue: false,
              contractDiscountValue: false,
              turnoverGx: false,
              turnoverOtc: false,
              turnoverDevelopmentGx: false,
              turnoverDevelopmentOtc: false,
              discountGx: false,
              discountGxVariable: false,
              discountOtc: false,
              marketingActivitiesGx: false,
              marketingActivitiesOtc: false,
              advertisementGx: false,
              otherMarketingGx: false,
              advertisementOtc: false,
              otherMarketingOtc: false
            }
          }
        })
      },
      loadRegions() {
        axios.get(`/api/system/regions?sortBy=region`).then(response => {
          this.regions = response.data.data
          this.regions.unshift({id: null, region: this.$t('sandoz.select')})
        })
      },
      isRegionVisible() {
        const type = this.$refs.form && this.$refs.form.item.type !== undefined ? this.$refs.form.item.type : null
        if (type) {
          const typeArray = type.split('_')
          const length = typeArray.length
          if (length) {
            const sectionType = length > 1 ? typeArray[length - 1] : typeArray[0]
            if (sectionType === 'PV' || sectionType === 'ONE' || sectionType === 'GADGET') {
              this.$refs.form.item.region_id = null
              return false
            }
          }
        }
        return true
      }
    },
    watch: {
      'formSchema.lines.product_id': function (newVal, oldVal){
        if(this.$refs.productSelector) {
          if(newVal !== oldVal) {
            let options = this.$refs.productSelector.$el.querySelector('select').options
            this.formSchema[this.form].product_name = options[options.selectedIndex].textContent
            this.custom_product_name = false
          }
        }
      },
    }
  }
</script>


<style>
.pdfFiles {
  border-bottom: none !important;
}

.pdfFiles .show-deleted-checkbox {
  text-transform: lowercase;
  font-weight: normal;
}

.bg-disable {
  background: lightgrey;
}
</style>
